(function () {
  let subId = null;
  fetch("https://www.salesenablementcollective.com/members/api/member/")
    .then((response) => response.json())
    .then((data) => {
      if (data.subscriptions && data.subscriptions.length > 0) {
        const id = data.subscriptions[0].id;
        subId = id;
        console.log("subId", subId);
      } else {
        console.log("No subscriptions found");
      }
    })
    .catch((error) => console.error("Error:", error));

  function attachClickListeners(iframe) {
    const frameContent = iframe.contentDocument;
    if(frameContent.querySelector(".gh-portal-products-pricetoggle")) {
      const toggleParent = frameContent.querySelector(
        ".gh-portal-products-pricetoggle"
      );

      // if (!toggleParent) {
      //   console.error("Could not find any toggle parent");
      //   return;
      // }
  
      toggleParent.addEventListener("click", function (event) {
        if (event.target.matches(".gh-portal-btn")) {
          setTimeout(function () {
            // setPortalPricing(iframe);
          }, 30);
        }
      });
    }
    
    if(frameContent.querySelector(".gh-portal-btn-destructive")) {
      const cancelSubscription = frameContent.querySelector(
        ".gh-portal-btn-destructive"
      );

      cancelSubscription.addEventListener("click", function (event) {
        console.log("Cancel subscription button clicked");
        event.preventDefault(); // Prevent default event behavior
  
        if (subId) {
          setTimeout(async function () {
            const result = await window.ProsperStack.flow({
              clientId: "acct_3sdTE9cHgS6KM8g6HRuvzEh0",
              subscription: {
                platformId: subId,
              },
            });
  
            switch (result.status) {
              case "canceled":
                // Process the cancellation and whatever other logic your application
                // requires when a customer cancels.
                console.log("canceled");
                break;
  
              case "saved":
                // The customer accepted an offer and didn't cancel. Churn prevented!
                // For most offers, no further action is needed.
                console.log(result.flowSession);
                console.log("saved");
  
                setTimeout(function () {
                  //backButton.click();
                  location.reload();
                }, 30);
  
              case "incomplete":
                // No action needed!
                console.log("incomplete");
  
                setTimeout(function () {
                  //backButton.click();
                  location.reload();
                }, 30);
  
                break;
            }
          });
        }
  
        // Add your custom code here to handle the cancel subscription functionality
      });
    }
    
    // const backButton = frameContent.querySelector(
    //   ".gh-portal-closeicon-container"
    // );

    
  }

  // function setPortalPricing(iframe) {
  //   const frameContent = iframe.contentDocument;
  //   const productCards = frameContent.querySelectorAll(
  //     ".gh-portal-product-card"
  //   );

  //   if (!productCards.length) {
  //     console.error("Could not find any product cards");
  //     return;
  //   }

  //   // Cache the active buttons
  //   const monthlyBtnActive =
  //     frameContent.querySelector(
  //       '[data-test-button="switch-monthly"].gh-portal-btn.active'
  //     ) != null;
  //   const yearlyBtnActive =
  //     frameContent.querySelector(
  //       '[data-test-button="switch-yearly"].gh-portal-btn.active'
  //     ) != null;

  //   // Map for product display mode
  //   const productDisplayMode = {
  //     "Pro+ membership": monthlyBtnActive ? "none" : "flex",
  //     "Exec+ membership": monthlyBtnActive ? "none" : "flex",
  //     Free: yearlyBtnActive ? "none" : "flex",
  //   };

  //   productCards.forEach(function (element) {
  //     const productNameElement = element.querySelector(
  //       ".gh-portal-product-name"
  //     );

  //     if (!productNameElement) {
  //       console.error("Could not find product name element in ", element);
  //       return;
  //     }

  //     const productName = productNameElement.textContent;
  //     console.log("productName", productName);

  //     element.style.display = productDisplayMode[productName] || "flex";
  //   });
  // }

  let intervalId;

  function callPortalIframe() {
    let portalIframe = document.querySelector("#ghost-portal-root iframe");

    if (portalIframe) {
      portalIframe.addEventListener("load", function () {
        // setPortalPricing(portalIframe);
        attachClickListeners(portalIframe);
        console.log("Pricing set and listeners attached");

        // listen to event click on button
        const viewPlansButton = portalIframe.contentDocument.querySelector(
          '.gh-portal-btn-main.gh-portal-btn-primary[data-test-button="view-plans"]'
        );

        if (viewPlansButton) {
          console.log(viewPlansButton);
          console.log("viewPlansButton was found!");
          clearInterval(intervalId); // Stop checking once the button is found

          viewPlansButton.addEventListener("click", function (event) {
            console.log("viewPlansButton was clicked!");
            setTimeout(function () {
              // setPortalPricing(portalIframe);
              attachClickListeners(portalIframe);
            }, 30);
          });
        } else {
          console.log("viewPlansButton was not found on the page");
          console.log(viewPlansButton);
        }

        const changePlansButton = portalIframe.contentDocument.querySelector(
          '.gh-portal-btn.gh-portal-btn-list[data-test-button="change-plan"]'
        );

        if (changePlansButton) {
          console.log(changePlansButton);
          console.log("changePlansButton was found!");
          clearInterval(intervalId); // Stop checking once the button is found

          changePlansButton.addEventListener("click", function (event) {
            console.log("changePlansButton was clicked!");
            setTimeout(function () {
              // setPortalPricing(portalIframe);
              attachClickListeners(portalIframe);
            }, 30);
          });
        } else {
          console.log("changePlansButton was not found on the page");
          console.log(changePlansButton);
        }

        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
      });
    } else {
      console.error("Could not find #ghost-portal-root iframe, retrying...");

      if (!intervalId) {
        intervalId = setInterval(callPortalIframe, 1000);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    console.log("DOM fully loaded");

    // let currentUrl = window.location.href;
    // let link = document.querySelector(
    //   'a[href="https://www.productmarketingalliance.com/#/portal/signup/"]'
    // );

    // if (link) {
    //   link.addEventListener("click", function (event) {
    //     console.log("Link was clicked!");
    //     callPortalIframe();
    //   });
    // } else {
    //   console.log("The link was not found on the page");
    // }
    // if (
    //   currentUrl ===
    //     "https://www.productmarketingalliance.com/#/portal/signup/" ||
    //   currentUrl ===
    //     "https://www.productmarketingalliance.com/#/portal/account/plans/"
    // ) {
    //   callPortalIframe();
    //   console.log("You are on the signup page");
    // } else if (
    //   currentUrl === "https://www.productmarketingalliance.com/#/portal" ||
    //   currentUrl ===
    //     "https://www.productmarketingalliance.com/account-free/#/portal" ||
    //   currentUrl ===
    //     "https://www.productmarketingalliance.com/pro-plus-membership-dashboard/#/portal" ||
    //   currentUrl === "https://www.productmarketingalliance.com/account/#/portal"
    // ) {
    //   callPortalIframe();
    //   console.log("You are on the portal/viewplans page");
    // } else {
    //   console.log("You are not on the signup/plan page");
    // }
    callPortalIframe();

    // Start observing the target node for configured mutations
    const targetNodePortalRoot = document.getElementById("ghost-portal-root");

    if (targetNodePortalRoot) {
      console.log("running observer");
      const config = { attributes: true, childList: true, subtree: true };

      const poratalObserver = new MutationObserver(function () {
        callPortalIframe();
      });
      poratalObserver.observe(targetNodePortalRoot, config);
    } else {
      console.error("Could not find #ghost-portal-root element");
    }
  });
})();